var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnemia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 347,
    viewBox: "0 0 375 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M206.163 237.572L199 226.586L191.829 237.586C191.11 238.688 190.731 239.954 190.731 241.242C190.731 245.283 194.438 248.566 199 248.566C203.563 248.566 207.269 245.283 207.269 241.242C207.269 239.954 206.89 238.688 206.163 237.572Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M157.654 189.973V285.676C157.654 289.717 161.36 293 165.923 293H232.077C236.639 293 240.346 289.717 240.346 285.676V189.973H157.654ZM199 263.215C185.32 263.215 174.192 253.358 174.192 241.242C174.192 237.401 175.33 233.61 177.495 230.277L191.837 208.283C194.792 203.749 203.207 203.749 206.163 208.283L220.496 230.263C222.669 233.61 223.807 237.401 223.807 241.242C223.807 253.358 212.679 263.215 199 263.215Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.039 204.621V211.945C108.039 224.062 119.167 233.918 132.846 233.918H141.115V204.621H108.039Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.885 204.621V233.918H265.154C278.833 233.918 289.961 224.062 289.961 211.945V204.621H256.885Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M248.615 86.9453H149.385C144.822 86.9453 141.115 90.2285 141.115 94.2695V109.406C141.115 113.447 144.822 116.73 149.385 116.73H248.615C253.178 116.73 256.885 113.447 256.885 109.406V94.2695C256.885 90.2285 253.178 86.9453 248.615 86.9453Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M269.999 43H128.001C107.877 43 91.5 57.5054 91.5 75.3296V128.346C91.5 136.979 95.2956 145.098 102.192 151.206C105.963 154.546 108.038 158.988 108.038 163.708V189.973H141.115V182.648C141.115 178.6 144.814 175.324 149.385 175.324H248.615C253.186 175.324 256.885 178.6 256.885 182.648V189.973H289.962V163.708C289.962 158.988 292.037 154.546 295.808 151.206C302.704 145.098 306.5 136.979 306.5 128.346V75.3296C306.5 57.5054 290.123 43 269.999 43ZM165.923 160.676C161.356 160.676 157.654 157.396 157.654 153.352C157.654 149.306 161.356 146.027 165.923 146.027C170.49 146.027 174.192 149.306 174.192 153.352C174.192 157.396 170.49 160.676 165.923 160.676ZM199 160.676C194.433 160.676 190.731 157.396 190.731 153.352C190.731 149.306 194.433 146.027 199 146.027C203.567 146.027 207.269 149.306 207.269 153.352C207.269 157.396 203.567 160.676 199 160.676ZM232.077 160.676C227.51 160.676 223.808 157.396 223.808 153.352C223.808 149.306 227.51 146.027 232.077 146.027C236.644 146.027 240.346 149.306 240.346 153.352C240.346 157.396 236.644 160.676 232.077 160.676ZM273.423 109.406C273.423 121.522 262.295 131.379 248.615 131.379H149.385C135.705 131.379 124.577 121.522 124.577 109.406V94.2695C124.577 82.1533 135.705 72.2969 149.385 72.2969H248.615C262.295 72.2969 273.423 82.1533 273.423 94.2695V109.406Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 70,
    y: 43,
    width: 258,
    height: 258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnemia);
export default __webpack_public_path__ + "static/media/Anemia.051e7699767ce11ae68126789c78156f.svg";
export { ForwardRef as ReactComponent };